import { IPopoverProps } from "./types";

export function getPopoverArrowTransform(
  arrowPosition: IPopoverProps["arrowPosition"]
): string {
  if (arrowPosition === "left-top") return "translateX(24px) !important";

  if (arrowPosition === "top-right" || arrowPosition === "top-center") {
    return "translateY(30px) !important";
  }

  return "unset";
}
